import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useRef, useEffect } from 'react';
import { Button, Cell, Modal, Navigation, Spacer, Text } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import ScrollableArea from 'components/ScrollableArea';
import { DeprecatedInputTextarea } from 'components/Input';
import { FaceIcon, OptionsSection } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const FeedbackFormModal = _ref => {
  let {
    ratings,
    selectedRating,
    isOpen,
    onClose,
    onSubmit,
    isOptionsVisible = true,
    isInputWithoutRatingOptions = false,
    isCloseActionVisible = true
  } = _ref;
  const {
    0: currentRating,
    1: setCurrentRating
  } = useState(selectedRating);
  const {
    0: selectedFeedback,
    1: setSelectedFeedback
  } = useState();
  const {
    0: message,
    1: setMessage
  } = useState('');
  const inputRef = useRef(null);
  const translate = useTranslate('help_center_feedback');
  useEffect(() => {
    setCurrentRating(selectedRating);
  }, [selectedRating]);
  useEffect(() => {
    var _selectedFeedback$cur;

    if (!selectedFeedback || !currentRating) return;

    if ((_selectedFeedback$cur = selectedFeedback[currentRating]) !== null && _selectedFeedback$cur !== void 0 && _selectedFeedback$cur.isInputActive) {
      var _inputRef$current;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }
  }, [currentRating, selectedFeedback]);

  function updateFeedbackOptions(_ref2) {
    var _feedback$rating, _feedback$rating2;

    let {
      finalized,
      rating = currentRating
    } = _ref2;
    const feedback = selectedFeedback || {};
    if (!rating) return;
    const options = (_feedback$rating = feedback[rating]) === null || _feedback$rating === void 0 ? void 0 : _feedback$rating.options;
    const isInputActive = (_feedback$rating2 = feedback[rating]) === null || _feedback$rating2 === void 0 ? void 0 : _feedback$rating2.isInputActive;

    if (finalized) {
      onSubmit({
        finalized,
        rating,
        message: isInputActive || isInputWithoutRatingOptions ? message : undefined,
        feedbackStatementIds: options !== null && options !== void 0 && options.length ? options : undefined
      });
      return;
    }

    onSubmit({
      rating
    });
  }

  function handleSubmit() {
    updateFeedbackOptions({
      finalized: true
    });
  }

  function handleClose() {
    setSelectedFeedback(undefined);
    setCurrentRating(undefined);
    setMessage('');
    onClose();
  }

  function handleFaceSelect(rating) {
    updateFeedbackOptions({
      rating
    });
    setCurrentRating(rating);
  }

  function handleMessageTyping(_ref3) {
    let {
      target
    } = _ref3;
    setMessage(target.value);
  }

  function handleOptionSelect(id, hasInput) {
    var _feedback$currentRati, _feedback$currentRati2;

    if (!currentRating) return;
    const feedback = selectedFeedback || {};
    const currentRatingSelection = ((_feedback$currentRati = feedback[currentRating]) === null || _feedback$currentRati === void 0 ? void 0 : _feedback$currentRati.options) || [];
    const isFeedbackOptionSelected = currentRatingSelection === null || currentRatingSelection === void 0 ? void 0 : currentRatingSelection.includes(id);
    const isInputActive = (_feedback$currentRati2 = feedback[currentRating]) === null || _feedback$currentRati2 === void 0 ? void 0 : _feedback$currentRati2.isInputActive;

    const draftSelectedFeedback = _objectSpread(_objectSpread({}, feedback), {}, {
      [currentRating]: {
        isInputActive: hasInput ? !isInputActive : isInputActive,
        options: isFeedbackOptionSelected ? currentRatingSelection.filter(option => option !== id) : [...currentRatingSelection, id]
      }
    });

    setSelectedFeedback(draftSelectedFeedback);
  }

  function renderRatings() {
    if (!ratings) return null;
    return /*#__PURE__*/_jsx(Cell, {
      children: /*#__PURE__*/_jsx("div", {
        className: "u-flexbox u-justify-content-center",
        children: ratings.ratingIds.map(id => /*#__PURE__*/_jsx(FaceIcon, {
          rating: id,
          isActive: currentRating === id,
          onClick: handleFaceSelect
        }, id))
      })
    });
  }

  function renderOptions() {
    var _selectedFeedback$cur2;

    if (!ratings || !currentRating || !isOptionsVisible) return null;
    const {
      options,
      title
    } = ratings.ratingOptions[currentRating];
    const selectedOptions = selectedFeedback === null || selectedFeedback === void 0 ? void 0 : (_selectedFeedback$cur2 = selectedFeedback[currentRating]) === null || _selectedFeedback$cur2 === void 0 ? void 0 : _selectedFeedback$cur2.options;
    return /*#__PURE__*/_jsx(OptionsSection, {
      onClick: handleOptionSelect,
      ratingOptionsTitle: title,
      options: options,
      selectedValues: selectedOptions
    });
  }

  function renderInput() {
    let isInputActive = false;

    if (currentRating && isInputWithoutRatingOptions) {
      isInputActive = true;
    } else if (!currentRating || !selectedFeedback) {
      return null;
    } else {
      var _selectedFeedback$cur3;

      isInputActive = (_selectedFeedback$cur3 = selectedFeedback[currentRating]) === null || _selectedFeedback$cur3 === void 0 ? void 0 : _selectedFeedback$cur3.isInputActive;
    }

    if (!isInputActive) return null;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "feedback-input__title",
        children: /*#__PURE__*/_jsx(Text, {
          text: translate('feedback_resolved.input_title'),
          type: Text.Type.Title
        })
      }), /*#__PURE__*/_jsx(DeprecatedInputTextarea, {
        ref: inputRef,
        maxRows: 5,
        value: message,
        name: "feedback_deny_comment",
        placeholder: translate('feedback_resolved.input_placeholder'),
        onChange: handleMessageTyping
      })]
    });
  }

  function renderActionButtons() {
    if (!currentRating) return null;
    return /*#__PURE__*/_jsxs("div", {
      className: "feedback-modal__actions",
      children: [/*#__PURE__*/_jsx(Button, {
        text: translate('actions.submit_feedback'),
        styling: Button.Styling.Filled,
        onClick: handleSubmit,
        testId: "feedback-resolved-submit"
      }), isCloseActionVisible && /*#__PURE__*/_jsx(Button, {
        text: translate('actions.close'),
        styling: Button.Styling.Flat,
        onClick: handleClose,
        testId: "feedback-resolved-close-button"
      })]
    });
  }

  return /*#__PURE__*/_jsx(Modal, {
    testId: "feedback-modal",
    show: isOpen,
    hasScrollableContent: true,
    children: /*#__PURE__*/_jsxs("div", {
      className: "u-fill-width",
      children: [/*#__PURE__*/_jsx(Navigation, {
        theme: "transparent",
        right: /*#__PURE__*/_jsx(Button, {
          styling: Button.Styling.Flat,
          onClick: handleClose,
          deprecatedIconName: "x",
          testId: "feedback-resolved-close",
          aria: {
            'aria-label': translate('actions.close')
          }
        })
      }), /*#__PURE__*/_jsxs(ScrollableArea, {
        children: [/*#__PURE__*/_jsx(Text, {
          width: Text.Width.Parent,
          alignment: Text.Alignment.Center,
          text: (ratings === null || ratings === void 0 ? void 0 : ratings.titleText) || translate('feedback_resolved.title'),
          type: Text.Type.Heading
        }), /*#__PURE__*/_jsx(Text, {
          width: Text.Width.Parent,
          alignment: Text.Alignment.Center,
          text: ratings === null || ratings === void 0 ? void 0 : ratings.subtitleText,
          type: Text.Type.Subtitle
        }), renderRatings(), renderOptions(), renderInput(), renderActionButtons()]
      }), /*#__PURE__*/_jsx(Spacer, {
        size: Spacer.Size.Large
      })]
    })
  });
};

export default FeedbackFormModal;